/**
 * Map backend field names (snake_case from API) to frontend field names (camelCase).
 * Shared across all templates.
 */

export const mapBackendToFrontendFields = (backendData: any): any => {
  if (!backendData || typeof backendData !== 'object') return {};

  const fieldMapping: Record<string, string> = {
    'gsms_cost_from_manufacturer': 'gsmsCostFromMfg',
    'gsms_net_cost_from_manufacturer': 'gsmsNetCostFromMfg',
    'gsms_handling_type': 'gsmsHndlgType',
    'gsms_cost': 'gsmsCost',
    'suggested_bid_price': 'suggestedBidPrice',
    'wac': 'wac',
    'gsms_profit': 'gsmsProfit',
    'va_annual_usage': 'vaAnnualUsage',
    'dod_annual_usage': 'dodAnnualUsage',
    'va_tms_percentage': 'vaTmsPercent',
    'dod_tms_percentage': 'dodTmsPercent',
    'total_tms_percentage': 'totalTmsPercent',
    'target_annual_usage': 'targetAnnualUsage',
    'contract_annual_revenue': 'contractAnnualRevenue',
    'contract_annual_gp': 'contractAnnualGP',
    'contract_annual_cost': 'contractAnnualCost',
    'government_savings_analysis': 'govSavingsAnalysis',
    'annual_tmop_savings': 'annualTmopSavings',
    'month_tmop_savings': 'monthlyTmopSavings',
    'tmop_percentage': 'tmopPercent',
    'gsms_iff_fee': 'gsmsIffFee',
    'gsms_marketing_fee': 'gsmsMarketingFee',
    'start_date': 'usagePeriodStartDate',
    'end_date': 'usagePeriodEndDate',
    'approved_by': 'approvedBy',
    'va_annual_nc_est': 'vaAnnualNcEst',
    'dod_annual_nc_est': 'dodAnnualNcEst',
    'ihs_annual_nc_est': 'ihsAnnualNcEst',
    'bop_annual_nc_est': 'bopAnnualNcEst',
    'nc_est_annual_usage': 'ncEstAnnualUsage',
    'contract_annual_usage': 'contractAnnualUsage',
    'proposed_new_ratio': 'proposedNewRatio',
    'awarded_fss_ratio': 'awardedFssRatio',
    'new_tc_price': 'newTcPrice',
    'max_price_without_iff': 'maxPriceWithoutIff',
    'max_price_with_iff': 'maxPriceWithIff',
    'gross_profit': 'grossProfit',
    'gp_per_unit': 'gpPerUnit',
    'ratio_ok': 'ratioOk',
    'max_price_ok': 'maxPriceOk',
    'gsms_bottle_capacity': 'gsmsBottleCapacity',
    'gsms_bottle_cost': 'gsmsBottleCost',
    'gsms_cap_cost': 'gsmsCapCost',
    'gsms_label_cost': 'gsmsLabelCost',
    'gsms_insert_cost': 'gsmsInsertCost',
    'gsms_box_or_carton_cost': 'gsmsBoxCartonCost',
    'gsms_dessicant_cost': 'gsmsDesiccantCost',
    'gsms_outsource_repack_fee': 'outsourceRepackFee',
    'blended_whls_fee': 'blendedWhlsFee',
    'gsms_frt_cost': 'gsmsFrtCost',
    'pv2_percent_cost': 'pv2Percent',
    'gsms_labor': 'gsmsLabor',
    'mfg_bottle_size': 'mfgBottleSize',
    'GSMSCostFromManufacturer': 'gsmsCostFromMfg',
    'GSMSNetCostFromManufacturer': 'gsmsNetCostFromMfg',
    'GSMSPackSize': 'gsmsPackSize',
    'GSMSHandlingType': 'gsmsHndlgType',
    'GSMSCost': 'gsmsCost',
    'SuggestedBidPrice': 'suggestedBidPrice',
    'WAC': 'wac',
    'GSMSProfit': 'gsmsProfit',
    'VAAnnualUsage': 'vaAnnualUsage',
    'DODAnnualUsage': 'dodAnnualUsage',
    'VATMSPercentage': 'vaTmsPercent',
    'DODTMSPercentage': 'dodTmsPercent',
    'TotalTMSPercentage': 'totalTmsPercent',
    'TargetAnnualUsage': 'targetAnnualUsage',
    'ContractAnnualRevenue': 'contractAnnualRevenue',
    'ContractAnnualGP': 'contractAnnualGP',
    'ContractAnnualCost': 'contractAnnualCost',
    'GovernmentSavingsAnalysis': 'govSavingsAnalysis',
    'AnnualTMOPSavings': 'annualTmopSavings',
    'MonthTMOPSavings': 'monthlyTmopSavings',
    'TMOPPercentage': 'tmopPercent',
    'GSMSIFFFee': 'gsmsIffFee',
    'GSMSMarketingFee': 'gsmsMarketingFee',
    'gsms_mfg_ndc': 'gsms_mfg_ndc',
    'gsms_ndc': 'gsms_ndc',
    'mfg_ndc': 'mfg_ndc',
    'GSMSmfgNDC': 'gsms_mfg_ndc',
    'GSMSNDC': 'gsms_ndc',
    'supplier_comparable_wac': 'supplier_comparable_wac',
    'SupplierComparableWAC': 'supplier_comparable_wac',
    'mode_wac': 'modeWac',
    'low_wac': 'lowWac',
    'top_rx_price': 'topRxPrice',
    'top_rx_vendor': 'topRxVendor',
    'cost_plus_price': 'costPlusPrice',
    'nadac_price': 'nadacPrice',
  };

  const mapped: any = {};

  if (backendData.gsms_pack_size !== null && backendData.gsms_pack_size !== undefined && backendData.gsms_pack_size !== '') {
    mapped.mfgBottleSize = backendData.gsms_pack_size;
  }
  if (backendData.mfg_bottle_size !== null && backendData.mfg_bottle_size !== undefined && backendData.mfg_bottle_size !== '') {
    mapped.mfgBottleSize = backendData.mfg_bottle_size;
  }

  const numericFields = [
    'gsmsCost', 'suggestedBidPrice', 'wac', 'supplier_comparable_wac', 'gsmsProfit', 'vaAnnualUsage',
    'dodAnnualUsage', 'vaTmsPercent', 'dodTmsPercent', 'totalTmsPercent',
    'targetAnnualUsage', 'contractAnnualRevenue', 'contractAnnualGP',
    'contractAnnualCost', 'govSavingsAnalysis', 'annualTmopSavings',
    'monthlyTmopSavings', 'tmopPercent', 'gsmsIffFee', 'gsmsMarketingFee',
    'gsmsCostFromMfg', 'gsmsNetCostFromMfg',
    'vaAnnualNcEst', 'dodAnnualNcEst', 'ihsAnnualNcEst', 'bopAnnualNcEst', 'ncEstAnnualUsage',
    'modeWac', 'lowWac', 'topRxPrice', 'costPlusPrice', 'nadacPrice',
    'gsmsBottleCost', 'gsmsCapCost', 'gsmsLabelCost', 'gsmsInsertCost', 'gsmsBoxCartonCost',
    'gsmsDesiccantCost', 'outsourceRepackFee', 'blendedWhlsFee', 'gsmsFrtCost', 'pv2Percent', 'gsmsLabor',
  ];

  const inputNumberNullFields = [
    'suggestedBidPrice', 'wac', 'supplier_comparable_wac', 'gsmsProfit',
    'modeWac', 'lowWac', 'topRxPrice', 'costPlusPrice', 'nadacPrice',
    'gsmsBottleCost', 'gsmsCapCost', 'gsmsLabelCost', 'gsmsInsertCost', 'gsmsBoxCartonCost', 'gsmsDesiccantCost',
    'outsourceRepackFee', 'blendedWhlsFee', 'gsmsFrtCost', 'pv2Percent', 'gsmsLabor', 'gsmsIffFee',
    'gsmsCostFromMfg', 'gsmsNetCostFromMfg', 'gsmsCost',
  ];

  const stringOnlyFields = ['gsms_ndc', 'gsms_mfg_ndc', 'mfg_ndc', 'selectedMfgNdc', 'gsmsBottleCapacity'];

  Object.keys(backendData).forEach((key) => {
    const frontendKey = fieldMapping[key] || key;
    const value = backendData[key];

    if (key === 'gsms_pack_size') return;

    if (value === null || value === undefined) {
      if (frontendKey === 'usagePeriodStartDate' || frontendKey === 'usagePeriodEndDate') {
        mapped[frontendKey] = null;
      } else if (numericFields.includes(frontendKey)) {
        mapped[frontendKey] = inputNumberNullFields.includes(frontendKey) ? null : '';
      } else {
        mapped[frontendKey] = '';
      }
    } else if (typeof value === 'number') {
      if (stringOnlyFields.includes(frontendKey)) {
        if (frontendKey === 'gsmsBottleCapacity') {
          mapped[frontendKey] = value.toString();
        } else {
          mapped[frontendKey] = (value % 1 === 0 ? Math.floor(value) : Math.floor(value)).toString();
        }
      } else if (inputNumberNullFields.includes(frontendKey)) {
        mapped[frontendKey] = value;
      } else {
        mapped[frontendKey] = value.toString();
      }
    } else if (typeof value === 'boolean') {
      mapped[frontendKey] = value;
    } else {
      mapped[frontendKey] = value;
    }
  });

  if (mapped.gsms_mfg_ndc && !mapped.mfg_ndc) mapped.mfg_ndc = mapped.gsms_mfg_ndc;
  if (mapped.mfg_ndc && !mapped.selectedMfgNdc) mapped.selectedMfgNdc = mapped.mfg_ndc;
  if (mapped.gsms_mfg_ndc && !mapped.selectedMfgNdc) mapped.selectedMfgNdc = mapped.gsms_mfg_ndc;

  return mapped;
};
